import common from './common/common';
import cookieService from './services/cookieService.js';
import consentModePrivacyService from './services/marketingAndAnalytics/consentModePrivacyService.js';
import gtagAndFqbInitService from './services/marketingAndAnalytics/gtagAndFqbInitService.js';
import marketingAndAnalyticsService from './services/marketingAndAnalytics/marketingAndAnalyticsService.js';
import { logError } from './tracing.js';
/*!
 * YACC (Yet Another Cookie Consent plugin) - Handle the EU cookie law with pure framework agnostic javascript
 */

if (!Function.prototype.bind) {
    Function.prototype.bind = function (oThis) {
        if (typeof this !== 'function')
            throw new TypeError(
                'Function.prototype.bind - what is trying to be bound is not callable'
            );
        var aArgs = Array.prototype.slice.call(arguments, 1),
            fToBind = this,
            fNOP = function () {},
            fBound = function () {
                return fToBind.apply(
                    this instanceof fNOP && oThis ? this : oThis,
                    aArgs.concat(Array.prototype.slice.call(arguments))
                );
            };
        fNOP.prototype = this.prototype;
        fBound.prototype = new fNOP();
        return fBound;
    };
}

class Yacc {
    constructor(opts) {
        const extendDefaults = (source, properties) => {
            var property;
            for (property in properties) {
                if (properties.hasOwnProperty(property))
                    source[property] = properties[property];
            }
            return source;
        };

        this.cookie = cookieService.getDefaultCookieConsentValues();

        const documentLang = common.getLang();
        var defaults = {
            debug: true,
            cookieExpirationDays: 180, // 6 mesi
            cookiePageUrl: '/cookies.html',
            culture: documentLang.includes('-')
                ? documentLang.split('-')[0]
                : documentLang,
        };
        this.options = defaults;
        if (opts && typeof opts === 'object')
            this.options = extendDefaults(defaults, opts);
        this.#log(this.options);

        this.#initialize(this.options);
        this.#log('Module loaded');
    }

    //Private methods  ////////////////////////////////////////////////////////////////////////////

    #isCookiesPolicyPage(cookiePageUrl) {
        return window.location.pathname === cookiePageUrl;
    }

    #log() {
        if (this.options.debug) console.log(...arguments);
    }

    #error() {
        console.error(...arguments);
        logError(...arguments);
    }

    #initialize(options) {
        /*jshint validthis:true */

        const initializeBannerNoCookies = (options) => {
            /*jshint validthis:true */

            const createBannerNoCookiesText = (culture) => {
                const bannerNoCookiesText = {
                    it: '<div class="cookie-consent-nocookies">Attenzione! I cookie non sono abilitati. Questo sito potrebbe non funzionare correttamente</div>',
                    en: '<div class="cookie-consent-nocookies">Warning! cookies are disabled. This site could not work correctly</div>',
                    de: '<div class="cookie-consent-nocookies">Warning! cookies are disabled. This site could not work correctly</div>',
                    es: '<div class="cookie-consent-nocookies">Warning! cookies are disabled. This site could not work correctly</div>',
                    fr: '<div class="cookie-consent-nocookies">Warning! cookies are disabled. This site could not work correctly</div>',
                };
                let message = bannerNoCookiesText[culture]
                    ? bannerNoCookiesText[culture]
                    : bannerNoCookiesText.en;
                return message;
            };

            var banner = document.getElementById('bannerNoCookies');
            this.#log('Showing the no cookies banner...');
            if (banner === null) {
                banner = document.createElement('div');
                banner.setAttribute('id', 'bannerNoCookies');
                banner.innerHTML = createBannerNoCookiesText(options.culture);
                document.body.appendChild(banner);
                this.#log('...no cookies banner created');
            } else
                this.#log(
                    '...no cookies banner already present. Doing nothing.'
                );
        };

        if (!cookieService.cookiesEnabled()) {
            this.#log('Cookies are not enabled...');
            //it is a waste to bind javascript to links and scroll, knowing that we cannot save the cookie.
            this.cookie.firstParty = false;
            this.cookie.thirdParty = false;
            this.cookie.showBanner = false;
            initializeBannerNoCookies(options);
            marketingAndAnalyticsService.initLibs().then(({gtag})=> {
                consentModePrivacyService.setDefault({gtag});
            });
        } else {
            this.#log('Cookies are enabled...');
            this.#getCookie();
            this.#initializeProperties();
            this.cookie.showBanner = this.#isGoogleBot()
                ? false
                : this.cookie.showBanner;
            this.handleBanner();
        }
    }

    #isGoogleBot() {
        var isGoogleBot =
            navigator.userAgent !== undefined
                ? /googlebot/i.test(navigator.userAgent)
                : false;
        this.#log('Is GoogleBot? ' + isGoogleBot);
        return isGoogleBot;
    }

    handleBanner() {
        /*jshint validthis:true */
        if (this.#isCookiesPolicyPage(this.options.cookiePageUrl)) {
            this.#log('In cookies policy page, so no need to show the banner');
            return;
        }

        const createBannerText = ({
            culture,
            buttonOkId,
            buttonCloseId,
            cookiePageUrl,
        }) => {
            let bannerText = {
                it: `<div class="{{bannerCssClass}}">Questo sito utilizza cookie, anche di terze parti, per abilitare le funzionalità del sito necessarie, tra cui analisi, targeting e personalizzazione. <br />
      Per saperne di più o modificare le tue preferenze <a class="cookie-consent__link" href="{{cookiePageUrl}}">clicca qui</a>.
      <br />
      <div style="display:flex; justify-content: center;">
      <a class="cookie-consent__button {{bannerAcceptClass}}" id="${buttonOkId}">Accetta</a>
      <a class="cookie-consent__button cookie-consent__button--close" id="${buttonCloseId}">Rifiuta</a>
      </div>
      </div>
      </div>`,
                en: `<div class="{{bannerCssClass}}">This site uses cookies, including third party cookies, to enable necessary site functionality, including analytics, targeting and personalisation. <br />
    To find out more or change your preferences <a class="cookie-consent__link" href="{{cookiePageUrl}}">click here</a>.
    <br />
    <div style="display:flex; justify-content: center;">
    <a class="cookie-consent__button {{bannerAcceptClass}}" id="${buttonOkId}">Accept</a>
    <a class="cookie-consent__button cookie-consent__button--close" id="${buttonCloseId}">Reject</a>
    </div>
    </div>
    </div>`,
                de:
                    '<div class="{{bannerCssClass}}">Diese Seite nutzt Cookies, einschließlich Cookies von Dritten, um Ihre Browser-Erfahrung zu verbessern. Wenn Sie mehr erfahren oder Ihre Einstellungen ändern möchten, klicken Sie <a class="cookie-consent__link" href="{{cookiePageUrl}}"> hier </a>. <br /> Durch Schließen dieses Banners, Scrollen oder durch Anklicken eines seiner Elemente, erklären Sie sich mit der Verwendung einverstanden. <a class="cookie-consent__button {{bannerAcceptClass}}" id="' +
                    buttonOkId +
                    '">Ok, verstanden</a> <a class="cookie-consent__button cookie-consent__button--close" id="' +
                    buttonCloseId +
                    '">Ablehnen</a></div></div>',
                es: `<div class="{{bannerCssClass}}">Este sitio utiliza cookie, incluyendo las de terceros, para permitir las funciones necesarias del sitio, tales como análisis, orientación y personalización. <br />
    Para obtener más información o cambiar tus preferencias <a class="cookie-consent__link" href="{{cookiePageUrl}}">haz clic aquí</a>.
    <br />
    <div style="display:flex; justify-content: center;">
    <a class="cookie-consent__button {{bannerAcceptClass}}" id="${buttonOkId}">Aceptar</a>
    <a class="cookie-consent__button cookie-consent__button--close" id="${buttonCloseId}">Rechazar</a>
    </div>
    </div>
    </div>`,
                fr: `<div class="{{bannerCssClass}}">Ce site utilise des cookies, y compris des tiers, pour améliorer votre expérience de navigation.
    Si vous voulez en savoir plus o modifier vos préférences <a class="cookie-consent__link" href="{{cookiePageUrl}}"> cliquez ici </a>. <br />
    <br />
    <div style="display:flex; justify-content: center;">
    <a class="cookie-consent__button {{bannerAcceptClass}}" id="${buttonOkId}">Accepter</a>
    <a class="cookie-consent__button cookie-consent__button--close" id="${buttonCloseId}">Refuser</a>
    </div>
    </div>
    </div>`,
            };
            let message = bannerText[culture]
                ? bannerText[culture]
                : bannerText.en;
            const bannerCssClass = 'cookie-consent';
            const bannerAcceptClass = 'cookie-consent__button--accept';
            return message
                .replace('{{bannerCssClass}}', bannerCssClass)
                .replace(/{{bannerAcceptClass}}/g, bannerAcceptClass)
                .replace('{{cookiePageUrl}}', cookiePageUrl);
        };

        if (this.cookie.showBanner) {
            this.#log('Showing the banner...');
            var banner = document.getElementById('bannerCookiesConsent');
            if (banner === null) {
                banner = document.createElement('div');
                banner.setAttribute('id', 'bannerCookiesConsent');
                banner.innerHTML = createBannerText({
                    culture: this.options.culture,
                    buttonOkId: 'btnCookieBannerOk',
                    buttonCloseId: 'btnCookieBannerClose',
                    cookiePageUrl: this.options.cookiePageUrl,
                });
                document.body.appendChild(banner);
                //After the creation of the banner or the bind on buttons will not work
                this.#initializeEvents({
                    buttonOkId: 'btnCookieBannerOk',
                    buttonCloseId: 'btnCookieBannerClose',
                    cookiePageUrl: this.options.cookiePageUrl,
                });
                this.#log('...banner created');
            } else this.#log('...banner already present. Doing nothing.');
        } else {
            this.#closeBannerCookiesConsent();
        }
    }

    #closeBannerCookiesConsent() {
        var banner = document.getElementById('bannerCookiesConsent');
        if (banner) {
            banner.parentNode.removeChild(banner);
        }
    }

    #processScripts(elements) {
        if (elements && elements.length > 0) {
            var script = null;
            for (var i = 0; i < elements.length; i++) {
                if (elements[i].getAttribute('type') === 'text/plain') {
                    if (elements[i].getAttribute('src') === null) {
                        //eval() of code in script or IE8 will blow away with "Unknown runtime error", it does not like the innerHTML in <script>
                        elements[i].setAttribute('type', 'text/javascript');
                        eval(elements[i].innerHTML);
                    } else {
                        script = document.createElement('script');
                        script.setAttribute('type', 'text/javascript');
                        script.setAttribute(
                            'src',
                            elements[i].getAttribute('src')
                        );
                        elements[i].parentNode.insertBefore(
                            script,
                            elements[i].nextSibling
                        );
                        elements[i].parentNode.removeChild(elements[i]);
                    }
                }
            }
        }
    }

    #initializeProperties() {
        /*jshint validthis:true */
        if (
            !isNaN(this.options.cookieExpirationDays) &&
            this.options.cookieExpirationDays > 0
        )
            this.cookie.expirationDays = this.options.cookieExpirationDays;
        this.#log('cookieExpirationDays: ' + this.cookie.expirationDays);
    }

    #initializeEvents({ buttonOkId, buttonCloseId, cookiePageUrl }) {
        const bindEvent = function (obj, eventName, method) {
            obj[window.addEventListener ? 'addEventListener' : 'attachEvent'](
                window.addEventListener ? eventName : 'on' + eventName,
                method,
                false
            );
        };

        /*jshint validthis:true */

        this.buttonOk = document.getElementById(buttonOkId);
        if (this.buttonOk) {
            this.#log('Bind button click');
            bindEvent(
                this.buttonOk,
                'click',
                this.#acceptCookiesButton.bind(this)
            );
        }
        this.buttonClose = document.getElementById(buttonCloseId);
        if (this.buttonClose) {
            this.#log('Bind button close click');
            bindEvent(
                this.buttonClose,
                'click',
                this.#denyCookiesButton.bind(this)
            );
        }
    }

    #_getShowBanner = (showBanner) =>
        this.#isGoogleBot() ? false : showBanner;

    #acceptCookies({ showBanner, firstParty, thirdParty, marketingParty }) {
        /*jshint validthis:true */

        let currentCookies = {
            firstParty,
            thirdParty,
            marketingParty,
            showBanner: this.#_getShowBanner(showBanner),
        };
        this.#log(
            'Accepting cookies firstParty: ' +
                currentCookies.firstParty +
                ', thirdparty: ' +
                currentCookies.thirdParty +
                ', marketingparty: ' +
                currentCookies.marketingParty +
                ', showBanner: ' +
                currentCookies.showBanner
        );
        if (!cookieService.setCookieConsent(currentCookies)) {
            this.#error('ERROR: Cookie not created');
        } else {
            this.#log('Cookie saved');
        }
        // this.handleBanner();
        return currentCookies;
    }
    #getCookie() {
        /*jshint validthis:true */
        var cookie = cookieService.existsCookieConsent();

        if (cookie !== null) {
            var values = cookieService.getDecodedCookieConsentValues();
            if (values !== null) {
                //Force string to bool
                this.cookie.firstParty = values.FirstParty;
                this.cookie.thirdParty = values.ThirdParty;
                this.cookie.marketingParty = values.MarketingParty;
                this.cookie.showBanner = values.ShowBanner;
                const cookieValues = {
                    showBanner: values.ShowBanner,
                    firstParty: values.FirstParty,
                    thirdParty: values.ThirdParty,
                    marketingParty: values.MarketingParty,
                };
                marketingAndAnalyticsService.initLibs().then(({gtag})=> {
                    consentModePrivacyService.setConsent({gtag, accept: cookieValues.marketingParty})
                });
                this.#log('Cookie found, reading values...', cookieValues);
                return cookieValues;
            }
            return cookie;
        }

        this.#log('Cookie not found, falling back to default values...');
        marketingAndAnalyticsService.initLibs().then(({gtag})=> {
            consentModePrivacyService.setDefault({gtag})
        });
        let defaultCookieValues = {
            showBanner: this.#_getShowBanner(true),
            firstParty: true,
            thirdParty: false,
            marketingParty: false,
        };
        this.#acceptCookies(defaultCookieValues);
        return defaultCookieValues;
    }
    #acceptCookiesButton(e) {
        //IE8 do acceptCookiesButtonnot support preventDefault()
        //TODO try to understand why with IE8 e is null
        if (e) e.preventDefault ? e.preventDefault() : (e.returnValue = false);
        //force to act even if are in cookies page and is the first visit
        cookieService.acceptAllAndDontShowBanner();
        marketingAndAnalyticsService.initLibs().then(({gtag})=>{
            consentModePrivacyService.setConsent({accept:true, gtag});
            this.#closeBannerCookiesConsent();
        });
    }

    #denyCookiesButton(e) {
        //IE8 do not support preventDefault()
        //TODO try to understand why with IE8 e is null
        if (e) e.preventDefault ? e.preventDefault() : (e.returnValue = false);
        //force to act even if are in cookies page and is the first visit
        this.#acceptCookies({
            showBanner: false,
            firstParty: true,
            thirdParty: false,
            marketingParty: false,
        });
        marketingAndAnalyticsService.initLibs().then(({gtag})=>{
            consentModePrivacyService.setConsent({accept: false, gtag});
            this.#closeBannerCookiesConsent();
        });
    }
    //End private methods /////////////////////////////////////////////////////////////////////////

    //Public methods  /////////////////////////////////////////////////////////////////////////////

    // CANNOT deny first party cookie -> we can because art. 122 comma 1 del D.Lgs. 196/2003
    handleScripts() {
        let thirdParty = this.cookie.thirdParty;
        let marketingParty = this.cookie.marketingParty;
        this.#log('Parsing for <script>');

        if (thirdParty) {
            let thirdPartyElementsScripts = document.querySelectorAll(
                `script.cookieConsentThird`
            );
            this.#log(
                'thirdPartyElementsScripts',
                Array.from(thirdPartyElementsScripts).map((s) => s.innerHTML)
            );
            this.#processScripts(thirdPartyElementsScripts);
        }

        if (marketingParty) {
            let marketingPartyElementsScripts = document.querySelectorAll(
                `script.cookieConsentMarketing`
            );
            this.#log(
                'marketingPartyElementsScripts',
                Array.from(marketingPartyElementsScripts).map(
                    (s) => s.innerHTML
                )
            );
            this.#processScripts(marketingPartyElementsScripts);
        }
    }

    //End public methods  /////////////////////////////////////////////////////////////////////////
}

export default Yacc;
